import script from "./deposit-record.vue?vue&type=script&setup=true&lang=js"
export * from "./deposit-record.vue?vue&type=script&setup=true&lang=js"

import "./deposit-record.vue?vue&type=style&index=0&id=0efa6f9a&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0efa6f9a"]])

export default __exports__